import React from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';
import withProps from 'recompose/withProps';

import ReviewChartBar from './ReviewChartBar';

import './reviewChart.scss';

export const enhance = withProps((props) => ({
	ratings: sortBy(props.ratingCounts, (rating) => -1 * rating.rating)
}));

export function ReviewChart({ ratings, totalReviews }) {
	return (
		<div className="review-chart">
			{ratings.map((rating) => (
				<ReviewChartBar
					rating={rating.rating}
					percentRating={parseInt((rating.count / totalReviews) * 100)}
					reviewCount={rating.count}
					key={rating.rating}
				/>
			))}
		</div>
	);
}

ReviewChart.propTypes = {
	/** List of rating count objects that contain a rating (1-5) and a count */
	ratings: PropTypes.arrayOf(PropTypes.shape({
		rating: PropTypes.number.isRequired,
		count: PropTypes.number.isRequired
	})),
	/** Total number of reviews */
	totalReviews: PropTypes.number.isRequired
};

ReviewChart.defaultProps = {
	ratings: []
};

export default enhance(ReviewChart);
